import React from 'react'
import { LoadingInstance, ErroredInstance, isLoading, isErrored } from 'rwwa-data-access'
import { BetAccountHolder } from '@mobi/api-types'
import { DesktopSpinner, Spinner } from '@mobi/component-library/Legacy/Spinner'
import {
  ContactDetails as ContactDetailsRepo,
  ContactDetailsKey,
} from '@core/Data/Account/contactDetails'
import { getContactDetailsFields } from '@core/Areas/ContactDetails/data-transforms'
import { connect } from '@core/Components/HOCs/connect'
import { ErrorMessage } from '@core/Components/Messages'
import { CloseAccountView } from './CloseAccountView'

export const CloseAccount = ({ isDesktop }: { isDesktop?: boolean }) => {
  return <ConnectContactDetails contactDetails={ContactDetailsKey} isDesktop={isDesktop} />
}

export const CloseAccountLoader = ({
  contactDetails,
  isDesktop,
}: {
  contactDetails: typeof LoadingInstance | typeof ErroredInstance | BetAccountHolder
  isDesktop?: boolean
}) => {
  if (isLoading(contactDetails)) {
    return isDesktop ? <DesktopSpinner /> : <Spinner />
  }

  if (isErrored(contactDetails)) {
    return <ErrorMessage>An error occurred while loading the "Close Account" page.</ErrorMessage>
  }

  const { isInternationalCustomer } = getContactDetailsFields(contactDetails)
  return (
    <CloseAccountView isInternationalCustomer={isInternationalCustomer} isDesktop={isDesktop} />
  )
}

const ConnectContactDetails: React.ComponentClass<{
  contactDetails: string
  isDesktop?: boolean
}> = connect({ contactDetails: ContactDetailsRepo })<{ isDesktop?: boolean }>(CloseAccountLoader)
